import moment from 'moment-timezone';

/**
  * @param utcDate - utc datetime string
  * @returns moment object for further formatting
*/
const convertToLocalTime = (utcDate) => {
  const currentUserTz = moment.tz.guess();
  // if no date is passed in or argument is not parsable by moment, return localized now
  if (!utcDate || !moment(utcDate).isValid()) {
    return moment.tz(currentUserTz).format();
  }

  return moment.tz(utcDate, currentUserTz);
};

export default convertToLocalTime;



// WEBPACK FOOTER //
// ./src/helpers/dateHelpers.js